import React from 'react'
import {Button} from '@chakra-ui/react'
import {ArrowLeftRight} from '../../../components/icons'
import PropTypes from 'prop-types'
import {trackEvent} from '../../../tracking/analytics'

const CompareCta = ({product}) => {
    if (!product?.c_cmsModuleId || !product?.c_cmsCtaLabel) {
        return null
    }

    return (
        <Button
            variant="outline"
            rightIcon={<ArrowLeftRight />}
            onClick={(e) => {
                e.preventDefault()
                trackEvent({
                    event: 'compare_strollers',
                    event_category: 'compare_strollers',
                    event_action: product.name
                })
                document
                    .getElementById(product?.c_cmsModuleId)
                    ?.scrollIntoView({behavior: 'smooth'})
            }}
        >
            {product?.c_cmsCtaLabel}
        </Button>
    )
}

CompareCta.propTypes = {
    product: PropTypes.object
}

export default CompareCta
